// Version : 1.0.0
// Author : AGALYA
import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** UPDATE DRIVING LICENCE SERVICE START *********************** */
export const drivingLicenceUpdate = (updateDrivingLicenceData: any) => {
	const data = {
		DrivingLicenceToken: updateDrivingLicenceData,
	};
	const url = `${API_URL}updateDrivingLicence`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE DRIVING LICENCE SERVICE END *********************** */
